import { defineModel } from "../define-model";

export type Competitor = {
	id: string;
	workspaceId: string;
	projectId: string;
	name: string;
	website: string | null;
	notes: string;
	createdById: string | null;
	archivedAt: string | null;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		competitor: Competitor;
	}
}

export const model = defineModel({
	name: "competitor",
	load: "eager",
	indexes: ["projectId"],
	defaults: ({ userId, workspaceId, now }) => ({
		workspaceId,
		website: null,
		notes: "",
		createdById: userId,
		archivedAt: null,
		createdAt: now,
		updatedAt: now,
	}),
	sort: (a, b) => a.createdAt.localeCompare(b.createdAt),
});
